// Config del nav del Sidebar. Pure data — sin lógica, sin reactividad.
// Cuatro exports:
//   ICONS                  — paths SVG feather-style (24x24, stroke 2)
//   NAV_GROUPS             — estructura jerárquica de grupos → items → children
//   FLAT_ITEMS             — flatMap de NAV_GROUPS para búsquedas por id
//   SISTEMA_ALLOWED_EMAILS — allowlist de emails que ven el grupo Sistema
//                            (config, integraciones). El sidebar filtra el
//                            grupo entero si user.email no está aquí.

// Emails autorizados a ver el grupo "Sistema" (configuración admin).
// Para roles más complejos, conviene mover esto a un flag del backend
// (e.g., user.is_admin).
export const SISTEMA_ALLOWED_EMAILS = Object.freeze([
    "steven@cforemoto.com",
    "administracion@cforemoto.com",
]);

export const ICONS = Object.freeze({
    // Parents (top-level)
    bank: "M3 21h18 M5 21V10 M9 21V10 M15 21V10 M19 21V10 M2 10h20 M5 7l7-4 7 4",
    list: "M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01",
    fileText: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8",
    barChart: "M3 3v18h18 M7 16v-7 M12 16v-3 M17 16v-10",
    layers: "M12 2L2 7l10 5 10-5z M2 17l10 5 10-5 M2 12l10 5 10-5",
    upload: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4 M17 8l-5-5-5 5 M12 3v12",
    dollar: "M12 1v22 M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
    sliders: "M4 21V14 M4 10V3 M12 21V12 M12 8V3 M20 21V16 M20 12V3 M1 14h6 M9 8h6 M17 16h6",

    // Sub-items — Reportes
    grid: "M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z",
    checkSquare: "M9 11l3 3L22 4 M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11",
    trendingUp: "M23 6l-9.5 9.5-5-5L1 18 M17 6h6v6",
    shoppingCart: "M9 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2z M20 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2z M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6",
    creditCard: "M21 4H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z M1 10h22",
    percent: "M19 5L5 19 M6.5 9a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z M17.5 20a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z",
    activity: "M22 12h-4l-3 9L9 3l-3 9H2",
    archive: "M21 8v13H3V8 M1 3h22v5H1z M10 12h4",
    target: "M12 12m-10 0a10 10 0 1 0 20 0 10 10 0 1 0-20 0 M12 12m-6 0a6 6 0 1 0 12 0 6 6 0 1 0-12 0 M12 12m-2 0a2 2 0 1 0 4 0 2 2 0 1 0-4 0",
    compass: "M12 12m-10 0a10 10 0 1 0 20 0 10 10 0 1 0-20 0 M16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36 6.36-2.12z",

    // Sub-items — Financiamiento
    columns: "M12 3v18 M3 9h18 M3 15h18 M3 3v18 M21 3v18",
    repeat: "M17 1l4 4-4 4 M3 11V9a4 4 0 0 1 4-4h14 M7 23l-4-4 4-4 M21 13v2a4 4 0 0 1-4 4H3",

    // Sub-items — Configuración
    users: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0z M23 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75",
    image: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z M9 11a2 2 0 1 1 0-4 2 2 0 0 1 0 4z M21 15l-5-5L5 21",
    tag: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z M7 7h.01",
    link: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71 M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71",
});

export const NAV_GROUPS = Object.freeze([
    {
        id: "data",
        label: "Data",
        items: [
            // Exclusión mutua por flujo: una empresa que usa el Libro Mayor
            // (has_ledger) ve "Plan de Cuentas" + "Data desde ERP", NO el
            // Conciliador ni el Clasificador (su data viene del mayor, no del
            // SII/clasificador). `hideWhenFlag` oculta el item cuando ese flag
            // del user es truthy. Ver índice "Desde Mayores" (columna D).
            { id: "conciliador", label: "Conciliación Bancaria", flag: "has_conciliator", hideWhenFlag: "has_ledger", icon: ICONS.bank },
            { id: "accounts_plan", label: "Plan de Cuentas", flag: "has_classificator", icon: ICONS.list },
            { id: "classificator", label: "Clasificador de Documentos", flag: "has_classificator", hideWhenFlag: "has_ledger", icon: ICONS.fileText },
            { id: "erp", label: "Data desde ERP", flag: "has_ledger", icon: ICONS.archive },
        ],
    },
    {
        id: "reportes",
        label: "Reportes Financieros",
        items: [
            // El antiguo ítem único "Reporte Financiero (beta)" se reemplazó por
            // tres ítems al mismo nivel: Dashboard (hoja) + Estado de Resultados
            // y Balance (cada uno desplegable con su propia sección). Las tres
            // secciones renderizan DashboardReports (ver Dashboard.vue) y los
            // children setean el ?tab.
            { id: "reports", label: "Dashboard", flag: "has_financial_report", icon: ICONS.grid },
            {
                id: "estado_resultados",
                label: "Estado de Resultados",
                flag: "has_financial_report",
                icon: ICONS.checkSquare,
                defaultTab: "resultados",
                children: [
                    { id: "resultados", label: "Resumen", icon: ICONS.checkSquare },
                    { id: "ventas", label: "Ventas", icon: ICONS.trendingUp },
                    { id: "costos", label: "Costos", icon: ICONS.shoppingCart },
                    { id: "gastos", label: "Gastos", icon: ICONS.creditCard },
                    { id: "rentabilidad", label: "Rentabilidad", icon: ICONS.percent },
                    { id: "no_oper", label: "No Operacional", icon: ICONS.activity },
                    { id: "kpis", label: "KPIs", icon: ICONS.target },
                ],
            },
            {
                id: "balance",
                label: "Balance",
                flag: "has_financial_report",
                icon: ICONS.layers,
                defaultTab: "balance_resumen",
                // Patrimonio sólo en el flujo Mayores (flag has_ledger).
                // Resumen/Pasivos/Patrimonio aún sin vista → ComingSoon en TAB_REGISTRY.
                children: [
                    { id: "balance_resumen", label: "Resumen", icon: ICONS.checkSquare },
                    { id: "activos", label: "Activos", icon: ICONS.archive },
                    { id: "pasivos", label: "Pasivos", icon: ICONS.creditCard },
                    { id: "patrimonio", label: "Patrimonio", icon: ICONS.columns, flag: "has_ledger" },
                    // Mismo formato que el KPIs de Estado de Resultados; el id
                    // propio (balance_kpis) evita colisionar con ese tab.
                    { id: "balance_kpis", label: "KPIs", icon: ICONS.target },
                ],
            },
            {
                id: "reporte",
                label: "Reporte Financiero",
                flag: "has_embedded_report",
                icon: ICONS.barChart,
                requireChartLoaded: true,
            },
        ],
    },
    {
        id: "proyecciones_financieras",
        label: "Proyecciones Financieras",
        // Ítems hoja que navegan a la sección "proyecciones" (renderiza
        // DashboardReports) con su tab. `section`/`tab` desacoplan el destino
        // del `id` del ítem — ver onParentClick/itemActive en MainLayout. Tabs
        // aún ComingSoon.
        items: [
            { id: "presupuesto", label: "Presupuesto", flag: "has_financial_report", section: "proyecciones", tab: "presupuesto", icon: ICONS.creditCard },
            { id: "proyeccion_caja", label: "Proyección de Caja", flag: "has_financial_report", section: "proyecciones", tab: "proyeccion_caja", icon: ICONS.compass },
        ],
    },
    {
        id: "financiamiento",
        label: "Financiamiento",
        items: [
            // { id: "fileUpload", label: "Subir Data", flag: "has_file_upload", icon: ICONS.upload },
            {
                flag: "has_financiamiento",
                id: "bancos", label: "Bancos",
                icon: ICONS.dollar,
            },
            {
                flag: "has_financiamiento",
                id: "factoring", label: "Factoring", icon: ICONS.repeat,
            },
        ],
    },
    {
        id: "sistema",
        label: "Sistema",
        // Grupo restringido por email. Si user.email no está en
        // SISTEMA_ALLOWED_EMAILS, el grupo completo (eyebrow + items) se
        // oculta del sidebar.
        requireEmailIn: "SISTEMA_ALLOWED_EMAILS",
        items: [
            {
                id: "configuracion",
                label: "Configuración",
                flag: null,
                icon: ICONS.sliders,
                children: [
                    { id: "roles", label: "Roles de usuarios", icon: ICONS.users },
                    { id: "logo", label: "Logo", icon: ICONS.image },
                    { id: "nombre", label: "Nombre", icon: ICONS.tag },
                    { id: "integraciones", label: "Integraciones", icon: ICONS.link },
                ],
            },
        ],
    },
]);

export const FLAT_ITEMS = NAV_GROUPS.flatMap((g) => g.items);
